import { defineTemplate } from 'src/utils';
import { macroCuotas1080x1920 } from './layouts/Cuotas-1080x1920';
import { PAYMENT_METHOD_TEXT_OPTIONS } from '../_shared/data/payment-method-options';
import { MACRO_MEDIA_BASE } from '../_shared/data/media';

const THUMB = `${MACRO_MEDIA_BASE}/templates/macro-cuotas/thumbnails/macro-cuotas.png`;

export const macroCuotas = defineTemplate({
  mode: 'wysiwyg',
  id: 'macro-cuotas',
  clientId: 'MACRO',
  handlerKey: 'MACRO',
  title: 'Cuotas',
  thumbnail: { url: THUMB, optimizedUrl: THUMB, aspectRatio: 'vertical' },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'event',
      label: 'Nombre del evento',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      defaultValue: 'Calamaro',
      required: true
    },
    {
      key: 'location',
      label: 'Ubicación',
      type: 'input',
      placeholder: 'Ubicación',
      defaultValue: 'Rosario',
      required: true
    },
    {
      key: 'payment-value',
      label: 'Cuotas',
      type: 'number',
      placeholder: 'Número de cuotas',
      defaultValue: 6,
      required: true
    },
    {
      key: 'payment-text',
      label: 'Texto cuotas',
      type: 'input',
      placeholder: 'Texto cuotas',
      defaultValue: 'cuotas sin interés',
      required: true
    },
    {
      key: 'payment-method-text',
      label: 'Texto principal',
      type: 'select',
      placeholder: 'Con Tarjetas de Crédito Visa Macro',
      required: true,
      defaultValue: 'Con Tarjetas de Crédito Visa Macro',
      options: PAYMENT_METHOD_TEXT_OPTIONS
    },
    {
      key: 'secondary-text',
      label: 'Texto secundario',
      type: 'input',
      placeholder: 'Texto secundario',
      defaultValue: 'Venta General: 18/6 a las 12hs',
      required: true
    },
    {
      key: 'footer-text',
      label: 'Texto inferior',
      type: 'input',
      placeholder: 'Texto inferior',
      defaultValue: 'CARTERA CONSUMO. CFTNA 0,00%',
      required: true
    },
    {
      key: 'background-image',
      label: 'Imagen de fondo',
      type: 'image',
      required: false
    }
  ],
  canvasBinding: {
    resolutions: [
      {
        id: '1080x1920',
        label: '1080×1920',
        canvasWidth: 1080,
        canvasHeight: 1920,
        type: 'image',
        layout: macroCuotas1080x1920
      }
    ],

    fieldBindings: [
      { kind: 'simple', fieldKey: 'event', pieceId: 'event', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'location', pieceId: 'location', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'payment-method-text', pieceId: 'payment-method-text', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'payment-value', pieceId: 'payment-value', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'payment-text', pieceId: 'payment-text', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'secondary-text', pieceId: 'secondary-text', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'footer-text', pieceId: 'footer-text', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'background-image', pieceId: 'background-image', bindingType: 'image-replace' }
    ]
  }
});
